import { useState } from 'react';


        // Reusable "How this desk works" explainer — gold-bordered, collapsible,
        // and remembers per-tab whether the analyst has hidden it (localStorage).
        // Open by default on a desk-sized screen; collapsed on a phone or a
        // portrait tablet, where a paragraph of guidance would push the work
        // itself below the fold. Tapping it opens it, and that choice sticks.
        const smallScreen = () => {
            try { return window.matchMedia('(max-width: 900px)').matches; } catch (e) { return false; }
        };
        function HowItWorks({ id, title, intro, steps }) {
            const key = 'veil_howto_' + id;
            const [open, setOpen] = useState(() => {
                try {
                    const v = localStorage.getItem(key);
                    if (v === 'closed') return false;
                    if (v === 'open') return true;
                    return !smallScreen();
                } catch (e) { return !smallScreen(); }
            });
            const toggle = () => setOpen(o => {
                const n = !o;
                try { localStorage.setItem(key, n ? 'open' : 'closed'); } catch (e) {}
                return n;
            });
            return (
                <div className="panel p-6 mb-8" style={{ borderLeft: '3px solid var(--gold)' }}>
                    <div className="flex items-center justify-between cursor-pointer" onClick={toggle}>
                        <div className="font-mono text-xs uppercase tracking-widest text-muted">{title || 'How this works'}</div>
                        <span className="font-mono text-xs text-dim uppercase tracking-widest select-none">{open ? '– Hide' : '+ Show'}</span>
                    </div>
                    {open && (
                        <div className="mt-2">
                            {intro && <p className="text-sm text-muted" style={{ lineHeight: '1.6' }} dangerouslySetInnerHTML={{ __html: intro }} />}
                            <ol className="text-sm text-muted mt-3" style={{ lineHeight: '1.7', paddingLeft: '18px', listStyle: 'decimal' }}>
                                {steps.map((s, i) => <li key={i} dangerouslySetInnerHTML={{ __html: s }} />)}
                            </ol>
                        </div>
                    )}
                </div>
            );
        }

export { HowItWorks };
